import { getFeatures } from 'src/features';
import { Features } from 'src/features/featureTypes';

export const usePopstarFeatures = (): Features => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const enabledFeatures = window['AtoZContext']?.employee?.enabledFeatures || [];
  return getFeatures(enabledFeatures);
};
